// extracted by mini-css-extract-plugin
module.exports = {"container":"ManualBankAccount_container__YhC9o","body":"ManualBankAccount_body__2mb7b","switchSelector":"ManualBankAccount_switchSelector__1hjZf"};